<template>
	<main :lang="pageLang">
		<HeroBanner />

		<article class="pc-aboutus">
			<BrandPhilosophySection />
			<section class="part-news" ref="relatedNews">
				<NewsReleaseSection :list="pressReleaseList" :loading="pressReleasePending" />
			</section>
			<section class="part-business" ref="cooperateRef">
				<BusinessSection :list="businessOfficesList" />
			</section>
			<!-- 老師/Mentor入駐 -->
			<!-- <section>
				<InstitutionEntrySection
					title="老師/Mentor入駐"
					desc="我們提供專業內容服務平台、服務工具、技術保障和最精準垂直用戶�? 並通過平台性質保障用戶和老師的權�? 降低糾紛風險, 歡迎加入我�? 攜手共創輝煌�?
					@apply="handleMentorEntry"
				/>
			</section> -->
			<!-- 机构入驻 -->
			<!-- <section ref="institutionEntryRef">
				<InstitutionEntrySection @apply="handleInstitutionEntry" />
			</section> -->

			<section>
				<CooperativeMediaSection />
			</section>

			<DownloadSection
				:apk-link="apkLink"
				@android-click="toAppStore('android')"
				@ios-click="toAppStore('ios')"
				@direct-download="handleDirectDownload"
			/>

			<!-- 品牌专访 -->
			<!-- <section class="part-access"> -->
			<!-- <h2 class="part-title">品牌專訪</h2>
				<article>
					<div class="pc-vedio-one">
						<a
							class="swiper-slide"
							href="http://hkdaily.net/info/m-yvo2ksb2kd.html"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="	《超能力學院》斬獲亞洲電視大獎最佳真人秀"
							@click="handleClick()"
						>
							<img :src="Banner0" class="pic-vedio" />
						</a>
					</div>
					<h3 class="vedio-title-one">
						《超能力學院》斬獲亞洲電視大獎最佳真人秀
						先知命局推動玄學內容國際化，第二季全球海選與品牌合作啟動
					</h3>
					<div class="vedio-news pc-center-1000">
						<div class="news-list">
							<a
								v-for="item in newsListZero"
								:key="item.title"
								target="_blank"
								:href="item.link"
								class="vedio-one"
								rel="noopener noreferrer"
								:aria-label="`查看新聞�?{item.desc}`"
								@click="handleClick(item)"
							>
								<figure class="news-img">
									<img :src="item.banner" :alt="item.desc" />
								</figure>
								<div class="news-center news-center1">
									<p class="news-desc">{{ item.desc }}</p>
								</div>
								<div class="bottom-detail">
									<div class="bottom-contain">
										<p>詳情</p>
										<div class="more-icon"></div>
									</div>
								</div>
							</a>
						</div>
					</div>
				</article> -->
			<!-- 第一部分 -->
			<!-- <article class="news-list-box">
					<div class="pc-vedio-one">
						<div class="swiper-wrapper">
							<a
								class="swiper-slide"
								href="https://www.youtube.com/watch?v=-PZo6cZK0KE&list=PLMrCeA6EKjLFbS9L5JYqL4Aw8S0sndU5E&index=3"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="觀看先知命局簽約梁思浩為代言人視�?
								@click="handleClick()"
							>
								<img :src="Banner1" class="pic-vedio" alt="先知命局簽約梁思浩為代言�? />
								<img class="swiper-button-prev" :src="VideoButton" alt="播放按鈕" />
								<div class="mask"></div>
							</a>
						</div>
					</div>
					<h3 class="vedio-title-one">先知命局簽約梁思浩為代言�?/h3>
					<div class="vedio-news pc-center-1000">
						<div class="news-list">
							<a
								v-for="item in newsListOne"
								:key="item.title"
								target="_blank"
								:href="item.link"
								class="vedio-one"
								rel="noopener noreferrer"
								:aria-label="`查看新聞�?{item.desc}`"
								@click="handleClick(item)"
							>
								<figure class="news-img">
									<img :src="item.banner" :alt="item.desc" />
								</figure>
								<div class="news-center news-center1">
									<p class="news-desc">{{ item.desc }}</p>
								</div>
								<div class="bottom-detail">
									<div class="bottom-contain">
										<p>詳情</p>
										<div class="more-icon"></div>
									</div>
								</div>
							</a>
						</div>
					</div>
				</article> -->
			<!-- 第二部分 -->
			<!-- <article class="access-two">
					<div class="pc-vedio-one">
						<div class="swiper-wrapper">
							<a
								class="swiper-slide"
								href="https://www.youtube.com/watch?v=Tbe11yx6j6k&list=PLMrCeA6EKjLFbS9L5JYqL4Aw8S0sndU5E&index=1"
								target="_blank"
								rel="noopener noreferrer"
								@click="handleClick()"
								aria-label="觀看先知命局聯合王晶工作室推出新概念玄學恐怖喜劇視�?
							>
								<img
									:src="Banner2"
									class="pic-vedio"
									alt="先知命局聯合王晶工作室推出新概念玄學恐怖喜�?
								/>
								<img class="swiper-button-prev" :src="VideoButton" alt="播放按鈕" />
								<div class="mask"></div>
							</a>
						</div>
					</div>
					<h3 class="vedio-title-one">先知命局聯合王晶工作室，推出新概念玄學恐怖喜�?/h3>
					<div class="vedio-news pc-center-1000">
						<div class="news-list">
							<a
								v-for="(item, index) in newsListTwo"
								:key="item.title"
								target="_blank"
								@click="handleClick()"
								:href="item.link"
								:class="{ 'highlight-third': index === 2 }"
								rel="noopener noreferrer"
								:aria-label="`查看新聞�?{item.desc}`"
							>
								<figure class="news-img">
									<img :src="item.banner" :alt="item.desc" />
								</figure>
								<div class="news-center">
									<p class="news-desc">{{ item.desc }}</p>
								</div> -->
			<!-- <div class="bottom-detail">详细&gt;</div> -->
			<!-- <div class="bottom-detail">
									<div class="bottom-contain">
										<p>詳情</p>
										<div class="more-icon"></div>
									</div>
								</div>
							</a>
						</div>
					</div>
				</article> -->
			<!-- </section> -->
			<!-- 品牌节目 -->
			<!-- <section class="part-show"> -->
			<!-- <div class="pc-center-1280 show-box">
					<h2 class="part-title">品牌節�?/h2>

					<article class="box">
						<div class="left">
							<img :src="video0" alt="常言道節目預�? />
						</div>
						<div class="right">
							<div class="pic">
								<img :src="box2" alt="常言道節目標�? />
							</div>
							<div class="content">
								<h3 class="content-title content-title0">先知命局呈獻：超能力學院</h3>
								<p>
									《超能力學院》一所跨越現實與未知的玄學競技學院�?5位術法新星�?位玄學導師，在真實競技中挑戰命運、覺醒潛能。這裏沒有劇本，只有考驗。每一次試煉，都是命運的拐點⋯�?
								</p>
								<a
									class="content-buttom"
									target="_blank"
									href="https://www.youtube.com/playlist?list=PLMrCeA6EKjLGIHSnYE3zuAuD4GzSAzpau"
									rel="noopener noreferrer"
									aria-label="觀看常言道節�?
									@click="handleClick1()"
								>
									<div class="buttom-button">
										<span>立即查看</span>
										<img :src="More2" alt="查看更多" />
									</div>
								</a>
							</div>
						</div>
					</article>
					<article class="box">
						<div class="right">
							<div class="content">
								<h3 class="content-title content-title1">先知命局 �?命運解惑�?/h3>
								<p>
									命運本身就有自身的秩序，但是面對一連串的抉擇，你，又點樣揀�?
									<br />《命運解惑師》為你解開人生困惑，無論家人、事業、運氣、愛情，甚至靈異經歷，為你整理思路，扭轉命局，帶來幸福指引，話唔定會有不一樣既結局！思路通，好運來！
								</p>
								<a
									class="content-buttom"
									target="_blank"
									href="https://www.youtube.com/playlist?list=PLMrCeA6EKjLENiNT-ZaJ_1D4aWC9pNKM_"
									rel="noopener noreferrer"
									aria-label="觀看命運解惑師節�?
									@click="handleClick1()"
								>
									<div class="buttom-button">
										<span>立即查看</span>
										<img :src="More2" alt="查看更多" />
									</div>
								</a>
							</div>
							<div class="pic">
								<img :src="box1" alt="命運解惑師節目標�? />
							</div>
						</div>
						<div class="left">
							<img :src="video1" alt="命運解惑師節目預�? />
						</div>
					</article>
					<article class="box">
						<div class="left">
							<img :src="video2" alt="常言道節目預�? />
						</div>
						<div class="right">
							<div class="pic">
								<img :src="box2" alt="常言道節目標�? />
							</div>
							<div class="content">
								<h3 class="content-title content-title2">先知命局 �?常言�?/h3>
								<p>
									由先知命局贊助，先知命局代言人梁思浩與雷電道長楓燧聯手打造的《常言道》節目。人生，會經歷萬千煩惱事，是要隨道也行，放下執著還是繼續尋求答案�?
									雷電道長楓燧與梁思浩一起解答你們的每一個煩惱�?帶你走出困局，悟出人生道理！
								</p>
								<a
									class="content-buttom"
									target="_blank"
									href="https://www.youtube.com/playlist?list=PLMrCeA6EKjLH5lHpWDx9tQC4wyVYGklAY"
									rel="noopener noreferrer"
									aria-label="觀看常言道節�?
									@click="handleClick1()"
								>
									<div class="buttom-button">
										<span>立即查看</span>
										<img :src="More2" alt="查看更多" />
									</div>
								</a>
							</div>
						</div>
					</article>
					<article class="box">
						<div class="right">
							<div class="content">
								<h3 class="content-title content-title3">先知命局呈獻：通靈之王2</h3>
								<p>
									世界上有幾多事情，可以超出大家的想像？通靈、超�?
									然能量、特異功能、偽科學等用詞，或都不足以形容�?
									股力量。突破第一輯，《通靈之王2》將加碼邀�?0�?
									參賽單位參加不同比拼，由主持梁思浩、王嘉慧、陳�?
									德出題考核，並負責監考崗位。來自五湖四海的異能�?
									士，誰人可以於多輪考核之中，運用自己超乎常人的�?
									力，通過所有關卡，最終成為新一屆通靈之王�?
								</p>
								<a
									class="content-buttom content-buttom3"
									target="_blank"
									href="https://www.youtube.com/playlist?list=PLWWM7d10LOwZyYw6P2oWwQpkaxIuVhmQE"
									rel="noopener noreferrer"
									aria-label="觀看通靈之王2節�?
									@click="handleClick1()"
								>
									<div class="buttom-button">
										<span>立即查看</span>
										<img :src="More2" alt="查看更多" />
									</div>
								</a>
							</div>

							<div class="pic">
								<img :src="box3" alt="通靈之王2節目標�? />
							</div>
						</div>
						<div class="left">
							<img :src="video3" alt="通靈之王2節目預�? />
						</div>
					</article>
				</div> -->
			<!-- </section> -->

			<!-- 品牌業務 -->
			<!-- <section class="part-serve">
				<div class="pc-center-1280 box-serve">
					<h2 class="part-title">品牌業務</h2>
					<div class="by-title">
						平台依托AI與大數據技術，打造集東方命理、西方占卜、身心療愈於一體的內容App，已服務超千萬用戶。匯聚麥玲玲、易烊楓燧等全球顶尖導師陣容，通過線下活動、原創節目等內容，致力於打造時代精神文化地標，助力用戶「先人一步，規劃人生旅途」�?
					</div>
					<ServeBanner />
				</div>
			</section> -->

			<!-- 在线测试 -->
			<!-- <section class="part-cesuan">
				<h2 class="part-title">先知命局在線測試</h2>
				<div class="cesuan-content">
					命運猶如重重迷霧，總讓人渴望一探究竟。超過百款線上命理測試等您挑戰。從古老神秘的八字學說，到影響生活的家居風水；從奇幻靈動的塔羅占卜，到耳熟能詳的星座運勢，一應俱全。我們的專業解析，定能為您撥開命運的迷霧，無論是初次接觸的好奇新手，還是鑽研命理的深度愛好者，都能在此踏上奇妙的命運探索之旅，趕緊前來揭開命運的神秘面紗吧�?
				</div>
				<NuxtLink to="/seer/onlinecs" class="cesuan-buttom" @click="handleClick2()">
					<div class="buttom-button">
						<span>馬上體驗</span>
						<img :src="More2" alt="體驗在線測試" />
					</div>
				</NuxtLink>
				<CesuanSlider />
			</section> -->
		</article>
	</main>
</template>

<script setup>
import { getAboutUsNewsList, getDownloadApk } from "~/api/api";
import { newsListOne, newsListTwo, newsListZero } from "../config";
import { computed, onMounted, ref, watch } from "vue";
import { downloadApp } from "~/utils/common";
import { useI18n } from "~/composables/useI18n";
import { ABOUT_SECTION_ID, useAboutUsTracking } from "../composables/useAboutUsTracking";
import { useAboutUsAnchorScroll } from "../composables/useAboutUsAnchorScroll";
import businessPicHk from "../images/shangwu1.png";
import businessPicTw from "../images/shangwu2.png";
import businessPicMy from "../images/shangwu3.png";
import Banner0 from "../images/1-0.png";
import Banner1 from "../images/1-1.jpg";
import Banner2 from "../images/2-1.jpg";
import VideoButton from "./images/video_button.png";
import video0 from "../images/video0.jpg";
import video1 from "../images/video1.jpg";
import video2 from "../images/video2.jpg";
import video3 from "../images/video3.jpg";
import box1 from "../images/box-one.png";
import box2 from "../images/box-two.png";
import box3 from "../images/box-three.png";
import HeroBanner from "./components/hero-banner/index.vue";
import BrandPhilosophySection from "./components/brand-philosophy-section/index.vue";
import BusinessSection from "./components/business-section/index.vue";
import ServeBanner from "./components/serve-banner/index.vue";
import CesuanSlider from "./components/cesuan-slider/index.vue";
import NewsReleaseSection from "./components/news-release/index.vue";
import DownloadSection from "./components/download-section/index.vue";
import InstitutionEntrySection from "./components/institution-entry-section/index.vue";
import CooperativeMediaSection from "./components/cooperative-media-section/index.vue";
import More2 from "./images/more2.png";

useMentorJoinFont();

const I18N_NS = "aboutUs";
const { t, locale, trackTranslationDeps } = useI18n();
const { track, observeImpression } = useAboutUsTracking("pc");
const pageLang = computed(() => (locale?.value === "en" ? "en" : "zh-TW"));
const heroBannerRef = ref(null);

const BUSINESS_OFFICE_IMAGES = [businessPicHk, businessPicTw, businessPicMy];
const OFFICE_CONTACT_COUNTS = [5, 4, 3];

const businessOfficesList = computed(() => {
	trackTranslationDeps();
	return BUSINESS_OFFICE_IMAGES.map((image, officeIndex) => ({
		title: t(`${I18N_NS}.business.offices.${officeIndex}.title`),
		image,
		contacts: Array.from({ length: OFFICE_CONTACT_COUNTS[officeIndex] }, (_, contactIndex) => ({
			icon: t(`${I18N_NS}.business.offices.${officeIndex}.contacts.${contactIndex}.icon`),
			text: t(`${I18N_NS}.business.offices.${officeIndex}.contacts.${contactIndex}.text`),
		})),
	}));
});

useHead(() => ({
	title: t(`${I18N_NS}.meta.title`),
	meta: [
		{ name: "keywords", content: t(`${I18N_NS}.meta.keywords`) },
		{ name: "description", content: t(`${I18N_NS}.meta.description`) },
		{ property: "og:title", content: t(`${I18N_NS}.meta.ogTitle`) },
		{ property: "og:description", content: t(`${I18N_NS}.meta.ogDescription`) },
		{ property: "og:type", content: "website" },
	],
}));

const route = useRoute();
const relatedNews = ref(null);
const cooperateRef = ref(null);
const institutionEntryRef = ref(null);
const elMap = ref({
	newsroom: relatedNews,
	cooperate: cooperateRef,
	join: institutionEntryRef,
});
// sticky header 约 80px，避免锚点被遮挡
const { scrollToTarget, scrollToEl, normalizeQueryParam } = useAboutUsAnchorScroll(elMap, {
	offset: 80,
});

const normalizeNewsTimestamp = value => {
	if (!value) {
		return 0;
	}

	const numericValue = Number(value);
	if (!Number.isNaN(numericValue) && numericValue > 0) {
		return numericValue < 1000000000000 ? numericValue * 1000 : numericValue;
	}

	const parsedTime = new Date(value).getTime();
	return Number.isNaN(parsedTime) ? 0 : parsedTime;
};

const formatNewsDate = value => {
	const timestamp = normalizeNewsTimestamp(value);
	if (!timestamp) {
		return "";
	}

	const date = new Date(timestamp);
	const year = date.getFullYear();
	const month = `${date.getMonth() + 1}`.padStart(2, "0");
	const day = `${date.getDate()}`.padStart(2, "0");
	return `${year}-${month}-${day}`;
};

const mapNewsItem = item => {
	const publishTime = item?.publish_time || item?.created_time || 0;

	return {
		...item,
		id: item?.id || item?.resource_id || item?.adv_id || "",
		title: item?.name || item?.title || item?.description || "",
		date: formatNewsDate(publishTime),
		banner:
			item?.pc_cover ||
			item?.cover ||
			item?.cover_en ||
			item?.cover_cc ||
			item?.banner ||
			item?.cover ||
			"",
		link: item?.actioncontent?.global_type || item?.link || "",
		publish_time: normalizeNewsTimestamp(publishTime),
	};
};

const { data: pressReleaseList, pending: pressReleasePending } = useLazyAsyncData(
	"aboutus-pc-news-release",
	async () => {
		try {
			const response = await getAboutUsNewsList();
			const rawList = Array.isArray(response)
				? response
				: Array.isArray(response?.data)
					? response.data
					: [];

			return rawList
				.map(mapNewsItem)
				.filter(item => item.title && item.link)
				.sort((a, b) => (b.publish_time ?? 0) - (a.publish_time ?? 0));
		} catch (error) {
			console.error("获取新闻发布列表失败:", error);
			return [];
		}
	},
	{
		default: () => [],
	}
);

watch(
	pressReleaseList,
	(list, prev) => {
		const to = normalizeQueryParam(route.query.to);
		if (!to) return;
		if ((prev?.length ?? 0) === 0 && (list?.length ?? 0) > 0) {
			scrollToTarget();
		}
	},
	{ flush: "post" }
);

// 使用useLazyAsyncData获取APK下载链接
const { data: apkLink } = useLazyAsyncData("downloadApk", async () => {
	const res = await getDownloadApk();
	return res.data.link;
});

const handleDirectDownload = () => {
	if (!import.meta.client) return;
	track("app_download_click", {
		store_type: "apk",
		section_id: ABOUT_SECTION_ID.APP_DOWNLOAD,
	});
};

const scrollToJoinEntry = () => {
	const join = normalizeQueryParam(route.query.join);
	if (!join) return;
	scrollToEl(institutionEntryRef, () => {
		handleInstitutionEntry();
	});
};

onMounted(() => {
	track("about_page_view");
	observeImpression("about_hero_view", heroBannerRef, () => {
		track("about_hero_view", {
			section_id: ABOUT_SECTION_ID.HERO,
			banner_id: "about_hero_banner",
		});
	});
	scrollToTarget();
	scrollToJoinEntry();
});

watch(
	() => normalizeQueryParam(route.query.join),
	(join, prev) => {
		if (join && join !== prev) scrollToJoinEntry();
	}
);

// 下載app - 客户端环境执�?
const toAppStore = type => {
	if (!import.meta.client) return;
	track("app_download_click", {
		store_type: type === "android" ? "google_play" : "app_store",
		section_id: ABOUT_SECTION_ID.APP_DOWNLOAD,
	});
	downloadApp(type);
};

// 处理老师/Mentor入驻点击
const handleMentorEntry = () => {
	if (import.meta.client) navigateTo("/seer/mentor-join");
};

// 处理机构入驻点击
const handleInstitutionEntry = () => {
	if (import.meta.client) navigateTo("/seer/corporate-center");
};
</script>

<style lang="scss" scoped>
main {
	width: 100%;
	max-width: 100%;
	overflow-x: clip;
}

.pc-aboutus {
	font-family: "Source Han Serif CN", serif;
	background-color: #ffffff;
	width: 100%;
	max-width: 100%;
	overflow-x: clip;

	.part-title {
		color: #c67f34;
		font-size: 40px;
		font-weight: 700;
	}
	.part-box {
		p {
			font-family: "Source Han Serif CN", serif;
			font-size: 22px;
			color: #643a2b;
			line-height: 38px;
		}

		.pic-part1 {
			position: relative;

			.pc-box {
				position: relative;
				left: 50%;
				transform: translateX(-50%);
				width: 80%;
				padding: 40px 0;

				.pc-box1 {
					position: relative;
					// margin-top: 40px;
					overflow: hidden;

					.pc-title {
						display: flex;
						justify-content: center;
						margin-bottom: 20px;

						h2 {
							position: static;
							font-size: 36px;
							color: #333333;
							font-weight: 700;
							text-align: center;
						}
					}
				}
			}

			.pc-content {
				margin: 0 auto;
				text-align: center;
				// width: 90%;
				color: #333333;
			}
		}
	}
	.part-access {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-top: 50px;

		.access-two {
			margin-top: 20px;
		}

		.news-list-box {
			margin-top: 30px;
		}

		.pc-vedio-one {
			width: 1154px;
			height: 504px;
			margin-top: 24px;
			width: 100%;
			position: relative;
			overflow: hidden;

			.swiper-slide {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				position: relative;
				border-radius: 12px;
				overflow: hidden;

				.pic-vedio {
					width: 100%;
					max-width: 100%;
					height: 100%;
					object-fit: cover;
					display: block;
					margin: 0 auto;
					border-radius: 12px;
				}
			}

			.swiper-button-prev {
				margin: -32px 460px 0;
				width: 64px;
				height: 64px;
			}

			a:hover {
				.swiper-button-prev {
					display: none;
				}

				.mask {
					position: absolute;
					width: 100%;
					height: 100%;
					top: 0;
					background: linear-gradient(
						to bottom,
						rgba(0, 0, 0, 0.5) 0%,
						rgba(0, 0, 0, 0) 20%,
						rgba(0, 0, 0, 0) 80%,
						rgba(0, 0, 0, 0.5) 100%
					);
					pointer-events: none;
				}
			}
		}

		.vedio-title-one {
			font-size: 20px;
			color: #333333;
			text-align: center;
			margin: 10px 0 30px;
			font-weight: 700;
		}

		.vedio-news {
			.news-list {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				a {
					position: relative;
					width: 230px;
					height: 310px;
					font-weight: 400;
					font-size: 16px;
					color: #222222;
					line-height: 21px;
					transition: all 0.2s ease;
					&:hover {
						color: #c67f34;

						.news-center {
							.news-desc {
								color: #c67f34;
							}
						}

						.bottom-detail {
							color: #c67f34;
							border: 1px solid #c67f34;
						}
					}

					.news-center {
						display: flex;
						justify-content: center;
						align-items: center;
						height: 130px;

						.news-desc {
							font-size: 20px;
							color: #222222;
							line-height: 30px;
						}
					}

					.news-center1 {
						height: 80px;
					}
					.news-img {
						width: 230px;
						height: 130px;
						overflow: hidden;
						margin-bottom: 10px;
						border-radius: 10px;
					}

					.bottom-detail {
						position: absolute;
						right: 0;
						bottom: 0;
						border: 1px solid #646a73;
						color: #646a73;
						width: 75px;
						height: 28px;
						border-radius: 14px / 50%;
						padding-top: 3px;

						.bottom-contain {
							display: flex;
							justify-content: center;
							align-items: center;

							p {
								margin-right: 2px;
								font-size: 16px;
							}

							.more-icon {
								width: 10px;
								height: 13px;
								background-image: url("./images/more.png");
								background-size: contain;
							}

							img {
								width: 15%;
								margin-left: 2px;
							}
						}
					}
				}

				.highlight-third {
					.news-center {
						margin-top: -15px;
					}
				}

				.vedio-one {
					height: 265px;
				}

				a:hover .bottom-contain .more-icon {
					background-image: url("./images/more3.png") !important;
				}
			}
		}
	}
	.part-business {
		background: #ffffff;
	}

	.part-show {
		margin-top: 50px;
		background-color: #fff8f1;

		.show-box {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			background-color: #fff8f1;
			padding: 50px 0;

			.box {
				margin: 30px 0;
				display: flex;
				justify-content: center;

				img {
					border-radius: 20px;
				}
			}

			.left,
			.right {
				flex: 1;
				margin: 0 30px;
			}

			.right {
				display: flex;

				.pic {
					flex: 1;

					img {
						width: 60px;
						height: 60px;
					}
				}

				.content {
					position: relative;
					flex: 6;
					color: #222222;
					font-size: 20px;

					.content-title1 {
						text-align: right;
						padding-right: 40px;
					}

					.content-title3 {
						text-align: right;
						padding-right: 20px;
					}

					.content-title {
						font-size: 36px;
						margin-bottom: 5px;
						font-weight: 700;

						// &2 {
						// 	position: relative;
						// 	right: -175px;
						// }
					}

					.content-buttom {
						position: absolute;
						bottom: 7px;
						color: #ffffff;
						width: 160px;
						height: 48px;
						line-height: 48px;
						background: linear-gradient(to right, #d9995e, #bc722f);
						border-radius: 10px;
						text-align: center;

						.buttom-button {
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 20px;

							img {
								width: 10%;
								margin-left: 5px;
							}
						}
					}

					.content-buttom3 {
						bottom: -20px;
					}
				}
			}
		}
	}

	.part-serve {
		background-color: #fff;

		.box-serve {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			padding: 50px 0;
			background-color: #fff;

			.by-title {
				margin: 30px 0;
				color: #643a2b;
				width: 920px;
				font-size: 24px;
				text-align: center;
			}
		}
	}

	.part-cesuan {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		background-color: #fff8f1;
		padding: 30px 0;

		.cesuan-content {
			margin: 30px 0;
			color: #643a2b;
			width: 900px;
			font-size: 24px;
			text-align: center;
		}

		.cesuan-buttom {
			font-size: 24px;
			width: 400px;
			height: 80px;
			color: #ffffff;
			line-height: 80px;
			background: linear-gradient(to right, #d9995e, #bc722f);
			border-radius: 10px;
			text-align: center;
			margin-bottom: 20px;

			.buttom-button {
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 5%;
					margin-left: 5px;
				}
			}
		}
	}
}

figure {
	margin: 0;
	padding: 0;
}
</style>
